export default __webpack_public_path__ + "static/assets/AllianceNo1Semibold.de5a3708.woff";